import { Button } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";
import {
  TemplateRegistry,
  TemplateDefinition,
} from "@/components/AIComponents/ExportablesModal/templates/registry";
import { leftPanelStyles } from "../ExportablesEditor.style";
import {
  listCss,
  defaultButtonCss,
  selectedButtonCss,
} from "./ExportablesTemplateGallery.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

function ExportablesTemplateGallery({
  exportables,
  selectedExportable,
  setSelectedExportable,
}: {
  exportables: TemplateRegistry;
  selectedExportable: TemplateDefinition<any> | null;
  setSelectedExportable: (exportable: TemplateDefinition<any>) => void;
}) {
  // Set the default exportable if none is selected
  if (!selectedExportable && Object.keys(exportables).length > 0) {
    setSelectedExportable(Object.values(exportables)[0]);
  }

  if (Object.keys(exportables).length === 0) {
    return <p>No exportable items available.</p>;
  }

  const getQaSelector = (exportable: TemplateDefinition<any>) => {
    const label = exportable?.label ?? exportable.title;
    return `preview-${label.replace(/\s+/g, "-").toLowerCase()}-exportable`;
  };

  const renderTemplates = () => {
    return Object.values(exportables).map((exportable) => (
      <li key={exportable.title}>
        {" "}
        <ButtonWithTrackEvent
          dataProps={{
            "data-qa-selector": getQaSelector(exportable),
          }}
          actionName={actionNames.preview}
          actionPrefix={actionPrefixes.initiate}
          objectType={objectTypes.generatedTextAsset}
          __cssFor={{
            root:
              selectedExportable?.title === exportable?.title
                ? selectedButtonCss
                : defaultButtonCss,
          }}
          onClick={() => setSelectedExportable(exportable)}
        >
          <h3>{exportable?.label ?? exportable.title}</h3>

          {exportable?.thumbnail && (
            <img src={exportable?.thumbnail} alt={exportable.title} />
          )}
        </ButtonWithTrackEvent>
      </li>
    ));
  };
  return (
    <div css={leftPanelStyles}>
      <ul css={listCss}>{renderTemplates()}</ul>
    </div>
  );
}

export default ExportablesTemplateGallery;
